/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as PagesRouteImport } from './routes/_pages'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as PagesArchiveRouteImport } from './routes/_pages.archive'
import { Route as PagesLibraryRouteImport } from './routes/_pages.library'
import { Route as PagesLicensesRouteImport } from './routes/_pages.licenses'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'

const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesRoute = PagesRouteImport.update({
  id: '/_pages',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const PagesArchiveRoute = PagesArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => PagesRoute,
} as any)
const PagesLibraryRoute = PagesLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => PagesRoute,
} as any)
const PagesLicensesRoute = PagesLicensesRouteImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => PagesRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/archive': typeof PagesArchiveRoute
  '/library': typeof PagesLibraryRoute
  '/licenses': typeof PagesLicensesRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRoutesByTo {
  '/': typeof ChatIndexRoute
  '/archive': typeof PagesArchiveRoute
  '/library': typeof PagesLibraryRoute
  '/licenses': typeof PagesLicensesRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/_pages': typeof PagesRouteWithChildren
  '/_pages/archive': typeof PagesArchiveRoute
  '/_pages/library': typeof PagesLibraryRoute
  '/_pages/licenses': typeof PagesLicensesRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/archive'
    | '/library'
    | '/licenses'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/archive'
    | '/library'
    | '/licenses'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
  id:
    | '__root__'
    | '/_chat'
    | '/_pages'
    | '/_pages/archive'
    | '/_pages/library'
    | '/_pages/licenses'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  PagesRoute: typeof PagesRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_pages': {
      id: '/_pages'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_pages/archive': {
      id: '/_pages/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof PagesArchiveRouteImport
      parentRoute: typeof PagesRoute
    }
    '/_pages/library': {
      id: '/_pages/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof PagesLibraryRouteImport
      parentRoute: typeof PagesRoute
    }
    '/_pages/licenses': {
      id: '/_pages/licenses'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof PagesLicensesRouteImport
      parentRoute: typeof PagesRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface PagesRouteChildren {
  PagesArchiveRoute: typeof PagesArchiveRoute
  PagesLibraryRoute: typeof PagesLibraryRoute
  PagesLicensesRoute: typeof PagesLicensesRoute
}

const PagesRouteChildren: PagesRouteChildren = {
  PagesArchiveRoute: PagesArchiveRoute,
  PagesLibraryRoute: PagesLibraryRoute,
  PagesLicensesRoute: PagesLicensesRoute,
}

const PagesRouteWithChildren = PagesRoute._addFileChildren(PagesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  PagesRoute: PagesRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
